export default __webpack_public_path__ + "static/engineering_challenges-4cad1cc6379b0b59e2f3560d65ada481.jpg";